import OrdersServices from "src/api-services/orders-services";
import { OrderStatus } from "src/enums/orderStatus";

export const createOrdersSlice = (set, get) => ({
  orders: [],
  ordersLoading: false,
  order: {
    items: [],
  },
  orderLoading: false,
  status: OrderStatus.pending,
  hasNewPending: false,
  unreadOrdersCount: 0,
  newOrderNotification: null,
  isNotificationVisible: false,
  notifiedOrderIds: new Set(), // تتبع الطلبات التي تم إشعارها مسبقاً

  fetchOrdersByStatusFunction: async (status, branch_id) => {
    set({ ordersLoading: true });
    try {
      const response = await OrdersServices.getOrderaByStatus(
        status,
        branch_id
      );
      set({ status: status, orders: response.data.data, ordersLoading: false });
      return response;
    } catch (error) {
      set({ ordersLoading: false });
      return error;
    }
  },
  UpdateOrderStatusFunction: async (data) => {
    set({ ordersLoading: true });
    try {
      const response = await OrdersServices.updateOrderStatus(data);
      const newOrders = get().orders.filter(
        (order) => order.id !== data.order_id
      );
      console.log(newOrders);
      set({ orders: newOrders, ordersLoading: false });
      return response;
    } catch (error) {
      set({ ordersLoading: false });
      return error;
    }
  },
  fetchOrderFunction: async (id) => {
    set({ orderLoading: true });
    try {
      const response = await OrdersServices.getOrder(id);
      set({ order: response.data.data, orderLoading: false });
    } catch (error) {
      set({ orderLoading: false });
    }
  },
  setStatus: (status) => {
    set({ status: status });
  },
  setOrder: (order) => {
    set({ order: order });
  },
  setNewOrderNotification: (order) => {
    const state = get();
    if (!state.notifiedOrderIds.has(order.id)) {
      state.notifiedOrderIds.add(order.id);
      set({
        newOrderNotification: order,
        isNotificationVisible: true,
        unreadOrdersCount: state.unreadOrdersCount + 1,
        notifiedOrderIds: state.notifiedOrderIds,
      });
    }
  },
  closeNotification: () => {
    set({
      isNotificationVisible: false,
      newOrderNotification: null,
    });
  },
  resetUnreadCount: () => {
    set({ unreadOrdersCount: 0 });
  },
  incrementUnreadCount: () => {
    set({ unreadOrdersCount: get().unreadOrdersCount + 1 });
  },
  refundOrderFunction: async (id, amount) => {
    set({ orderLoading: true });
    try {
      const response = await OrdersServices.refundOrder(id, amount);
      const newOrders = get().orders.map((order) => {
        if (order.id === id) order = response.data.data.order;
        return order;
      });
      set({ orders: newOrders, orderLoading: false });
      return { success: true, data: response.data };
    } catch (error) {
      set({ orderLoading: false });
      return { success: false, error };
    }
  },
});
